import { onError } from 'apollo-link-error';
import StorageService from '@/services/StorageService';
import AuthenticationService from '@/services/AuthenticationService';
import router from '../router/Router';

export default onError(({ networkError, graphQLErrors }) => {
  if (graphQLErrors) {
    graphQLErrors.map(({ message, locations, path }) => console.error( // eslint-disable-line no-console
      `[GraphQL error]: Message: ${message}, Location: ${locations}, Path: ${path}`,
    ));
    return;
  }

  if (networkError.statusCode === 401) {
    StorageService.remove('loggedUser');
    AuthenticationService.silentLogin();
  } else if (networkError.statusCode === 403) {
    router.push('/forbidden');
  } else if (networkError.statusCode === 500) {
    router.push('/error');
  }
});
